import { notification } from "antd";

// Success/error pop-ups shown at the top right.
//
// The call style matches the old react-s-alert API (`Alert.success("...")`,
// `Alert.error("...")`), so callers only changed their import. This is the
// only file (with NotificationHost.jsx) that knows antd is used, so the
// library can be swapped here later.

const DEFAULTS = {
	placement: "topRight",
	duration: 5,
};

// Set by <NotificationHost/> once it mounts, so notifications render inside
// the app's React tree (antd's recommended setup). Before that, fall back to
// antd's static API.
let api = null;

export function registerNotificationApi(instance) {
	api = instance;
}

const show = (type, text) => {
	const target = api || notification;
	target[type]({ ...DEFAULTS, title: text });
};

const notify = {
	success: (text) => show("success", text),
	error: (text) => show("error", text),
};

export default notify;
